const React = require('react');

const {backLocation} = require('../../../../../router');
const checkingForUpdatesProvider = require('../../../../../utils/checkingForUpdatesProvider');
const toEllipsisMiddle = require('../../../../../utils/toEllipsisMiddle');

const WrapperWithLoading = require('../../../../dumb/WrapperWithLoading/B');
const Caption = require('../../../../dumb/Caption/C');
const withState = require('../../../../../utils/withState');
const ButtonBack = require('../../../../dumb/Button/BackB');
const Button = require('../../../../dumb/Button/M');

const PrimaryDataDisplay = require('./PrimaryDataDisplay');
const SecondaryDataDisplay = require('./SecondaryDataDisplay');
const {apiV2AppGet} = require("../../../../../api/merchant/application");
const {pushLocation} = require("../../../../../router");
const {LINK_EDIT_APP, LINK_DEVELOPER_OPTIONS} = require("../../../../../constants/links");
const {apiV2CryptoWalletsList} = require("../../../../../api/merchant/cryptoWallet");

module.exports = withState((setState) => {
  const checkingForUpdates = checkingForUpdatesProvider(setState, (params) => {
    return apiV2AppGet({
      id: params.appId
    }).then((appData) => {
      return apiV2CryptoWalletsList({appId: params.appId}).then((wallets) => {
        const walletsList = wallets.list.map((el) => el.cc_code);
        return {...appData, wallets: walletsList};
      })
    });
  });

  return (state, props) => {
    const params = props.params || {};

    checkingForUpdates(params);

    const data = state.data || {};

    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <div className="layoutRow jcSB aiC fxwWrap dB@m">
          <div className="layoutRow aiC fxwWrap">
            <ButtonBack
              className="m-10 mr24"
              onClick={() => {
                pushLocation({
                  path: LINK_DEVELOPER_OPTIONS
                })
              }}
            />
            <Caption className="fxUnset@m mr24 mv10@m">
              App details
            </Caption>
            <div className="f23 fw3 lh34 mv10@m">
              {toEllipsisMiddle(data.id, 15)}
            </div>
          </div>
        </div>
        <PrimaryDataDisplay data={data} />
        <div className="h1 bgDADCE1 mt45 mb45"/>
        <SecondaryDataDisplay data={state.data}/>
        <div className="w268 mt34 mr64">
          <Button onClick={() => {
            pushLocation({
              path: `${LINK_EDIT_APP}/${params.appId}`
            })
          }}>
            Edit App
          </Button>
        </div>
      </WrapperWithLoading>
    );
  };
});
